// The Sentinel Workspace filter menus, from Figma section 1049:42795 "Filters (Ticket/status/followup)".
// Raw hex because these are design-system values with no Tailwind token behind them yet, as in menu-styles.

/**
 * The view switch and its follow-up submenu (Figma "Menu", 1047:38318 and 1070:47914): white, a 1px
 * #f4f4f6 border, 16px radius, 6px padding, 2px between rows, Elevation-Bottom/2.
 */
export const MENU_PANEL =
  'flex flex-col gap-[2px] rounded-[16px] border border-solid border-[#f4f4f6] bg-white p-[6px] shadow-none drop-shadow-[0px_3px_6px_rgba(0,0,0,0.12)] backdrop-blur-[6px]';

/**
 * The status menu (Figma "Menu-Slot / Ticket status", 1049:39222): white at 80%, a 1px #e5e7eb
 * border, 16px radius, 6px padding, rows flush, Elevation-Bottom/1.
 */
export const STATUS_PANEL =
  'flex flex-col gap-0 rounded-[16px] border border-solid border-[#e5e7eb] bg-[rgba(255,255,255,0.8)] p-[6px] shadow-[0px_3px_12px_0px_rgba(0,0,0,0.08)] backdrop-blur-[6px]';

/**
 * One Menu Item, Small and single-line: 28px tall, 8px across, 4px down, 10px radius, 8px between
 * its parts. Hovering, and a row whose submenu is open, take the "Open" state's #f4f4f6 fill; the
 * label keeps its colour (the primitive would grey it).
 */
export const MENU_ITEM =
  'flex min-h-[28px] w-full cursor-pointer items-center gap-[8px] rounded-[10px] px-[8px] py-[4px] text-[13px] leading-[18px] font-normal text-[#2b2e34] outline-hidden select-none focus:bg-[#f4f4f6] focus:text-[#2b2e34] data-[state=open]:bg-[#f4f4f6] data-[state=open]:text-[#2b2e34]';

/** A submenu row: the primitive adds its own chevron last, which gives way to the design's. */
export const MENU_SUB_TRIGGER = `${MENU_ITEM} [&>svg:last-child]:hidden`;

/** The label row: the label and its inline meta, 6px apart. */
export const MENU_LABEL_ROW = 'flex min-w-0 flex-1 items-center gap-[6px] whitespace-nowrap';

/** The count or current value beside a label ("Inline meta"): Body-sm/Regular, text/subtle. */
export const MENU_META = 'font-normal text-[#7c828d]';

/** A group label inside a menu (Menu-Section-Header, Small): Caption/Medium, text/subtle. */
export const MENU_SECTION = 'px-[8px] pt-[8px] pb-[4px] text-[12px] font-medium leading-[16px] text-[#7c828d]';

/** The divider between groups (Menu-Divider): 4px above and below the 1px rule. */
export const MENU_DIVIDER = 'flex w-full flex-col py-[4px]';
